/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Name_MissingInputs */

const en_editor_name_missing = /** @type {(inputs: Editor_Name_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which ingredient?`)
};

const de_editor_name_missing = /** @type {(inputs: Editor_Name_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Zutat?`)
};

/**
* | output |
* | --- |
* | "Which ingredient?" |
*
* @param {Editor_Name_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_name_missing = /** @type {((inputs?: Editor_Name_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Name_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_name_missing(inputs)
	return en_editor_name_missing(inputs)
});